import { Dashboard } from '@components/dashboard';
import { FunctionComponent } from 'react';

export type OverviewProps = {
  gid: string;
};

export const Overview: FunctionComponent<OverviewProps> = (props) => {
  const { gid } = props;
  return <Dashboard incentiveGids={[gid]} />;
};
